import { useMutation, useQuery } from '@tanstack/react-query';

import {
  clickSmartOffer,
  closeSmartOffer,
  getSmartOffer,
} from '@/components/shared/components/smart-offers/services';

import { CLICK_SMART_OFFER, CLOSE_SMART_OFFER, GET_SMART_OFFER } from '@/constant/query-key';

export function useGetSmartOffer(currentUrl: string) {
  return useQuery({
    queryFn: () => getSmartOffer(currentUrl),
    queryKey: [GET_SMART_OFFER, currentUrl],
  });
}

export function useCloseSmartOffer() {
  return useMutation({
    mutationFn: (id: string) => closeSmartOffer(id),
    mutationKey: [CLOSE_SMART_OFFER],
  });
}

export function useClickSmartOffer() {
  return useMutation({
    mutationFn: (id: string) => clickSmartOffer(id),
    mutationKey: [CLICK_SMART_OFFER],
  });
}
